import React, { type FormEvent } from "react";
import * as Styled from "../stylesView&Create";
import Alert from "@components/common/Alert";
import { LoginContext } from "@context/loginContext";
import { OportunityContext } from "@context/oportunityContex";
import InputSelectSearch from "@components/Sales/Inputs/InputSelectSearch";
import enterprisesService from "@services/Enterprises/enterprisesService";
import {
  optionCreditRating,
  optionEnterprise,
  optionNeighborhoods,
  optionTypology,
} from "../../components/options";
import Button from "@components/common/Button";
import Spinner from "@components/common/Spinner";
import unityService from "@services/Unity/unityService";
import quotesService from "@services/Quotes/QuotesService";
import oportunityService from "@services/Oportunity/OportunityService";
import InputSelectWithService from "@components/Sales/Inputs/InputSelectWithService";
import {
  Box,
  CloseButton,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useMessageErrorToast } from "@hook/useMessageErrorToast";
import type {
  ICreateQuotesComponent,
  IHashMapKeyString,
} from "src/@types/Sales";
import { theme } from "src/styles/theme";
import useWindowDimensions from "@hook/useWindowDimensions";
import InputText from "@components/Sales/Inputs/InputText";
import { IconLupaError } from "src/assets/IconLupaError";
import TableUnity from "@components/Quotes/TableUnity";
import { BiSearch } from "react-icons/bi";
import { formatMoney } from "@helpers/format";
import { MdHomeWork, MdOutlineEdit } from "react-icons/md";

type TableRow = {
  idUnidadeSales: string;
  idEmpreendimentoSales: string;
  nomeEmpreendimento: string;
  identificador: string;
  tipoPlanta: string;
  valorFinalKit: number;
  valorAvalBancaria: number;
  bonusAdimplencia: number;
};

const initialUnity = {
  idUnidadeSales: "",
  idEmpreendimentoSales: "",
  nomeEmpreendimento: "",
  identificador: "",
  tipoPlanta: "",
  valorFinalKit: 0,
  valorAvalBancaria: 0,
  bonusAdimplencia: 0,
};

const CreateQuotesComponent = ({
  onBack,
  setSuccessCreateQuote,
  setIsEdit,
  setHash,
}: ICreateQuotesComponent) => {
  const toast = useToast();
  const displayMessageError = useMessageErrorToast();
  const { width } = useWindowDimensions();
  const isMobile = width < 768; // 768px é o breakpoint md padrão do Chakra UI
  const idCorretor: any = localStorage.getItem("@idCorretor");
  const {
    accessCreateOp,
    accessQuote,
    setAccessQuote,
    regionalOp,
    ranking,
    hashCreateQuote,
    setHashCreateQuote,
  } = React.useContext(OportunityContext);
  const { signOut } = React.useContext(LoginContext);
  const [isUnauthorized, setIsUnauthorized] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [require, setRequire] = React.useState(false);

  //Empreendimentos
  const [dataEnterprises, setDataEnterprises] = React.useState([]);
  const [loadingEnterprises, setLoadingEnterprises] = React.useState(false);
  const [idEnterprises, setIdEnterprises] = React.useState("");
  const [enterprises, setEnterprises] = React.useState("");
  const [selectEnterprises, setSelectEnterprises] = React.useState("");

  //Unidade
  const [dataUnity, setDataUnity] = React.useState([]);
  const [loadingUnity, setLoadingUnity] = React.useState(false);
  const [unity, setUnity] = React.useState<TableRow>(initialUnity);

  //Condição de Pagamento
  const [dataPaymentTerms, setDataPaymentTerms] = React.useState([]);
  const [dataDescription, setDataDescription] = React.useState([]);
  const [loadingPaymentTerms, setLoadingPaymentTerms] = React.useState(false);
  const [idPaymentTerms, setIdPaymentTerms] = React.useState("");
  const [paymentTerms, setPaymentTerms] = React.useState("");

  //Avaliação de Crédito
  const [dataCreditRating, setDataCreditRating] = React.useState([]);
  const [loadingCreditRating, setLoadingCreditRating] = React.useState(false);
  const [idCreditRating, setIdCreditRating] = React.useState("");
  const [creditRating, setCreditRating] = React.useState("");
  const [selectCreditRating, setSelectCreditRating] = React.useState("");

  //Bairro
  const [dataNeighborhoods, setDataNeighborhoods] = React.useState([]);
  const [loadingNeighborhoods, setLoadingNeighborhoods] = React.useState(false);
  const [neighborhoods, setNeighborhoods] = React.useState("");
  const [selectNeighborhoods, setSelectNeighborhoods] = React.useState("");
  const [idNeighborhoods, setIdNeighborhoods] = React.useState("");

  //Tipologia
  const [dataTypology, setDataTypology] = React.useState([]);
  const [loadingTypology, setLoadingTypology] = React.useState(false);
  const [typology, setTypology] = React.useState("");
  const [selectTypology, setSelectTypology] = React.useState("");

  const [valueMin, setValueMin] = React.useState("");
  const [valueMax, setValueMax] = React.useState("");
  const [search, setSearch] = React.useState("");

  const renderedOptions = optionEnterprise(
    dataEnterprises,
    selectEnterprises,
    setSelectEnterprises,
    setEnterprises,
    setIdEnterprises
  );

  const renderedOptionsNeighborhoods = optionNeighborhoods(
    dataNeighborhoods,
    selectNeighborhoods,
    setSelectNeighborhoods,
    setNeighborhoods,
    setIdNeighborhoods
  );

  // const renderedOptionsUnity = optionUnity(
  //   dataProduct,
  //   selectProduct,
  //   setSelectProduct,
  //   setProduct,
  //   setIdProduct
  // );

  const renderedOptionsTypology = optionTypology(
    dataTypology,
    selectTypology,
    setSelectTypology,
    setTypology
  );

  const renderedOptionsCreditRating = optionCreditRating(
    dataCreditRating,
    selectCreditRating,
    setSelectCreditRating,
    setCreditRating,
    setIdCreditRating
  );

  const handleGetEnterprises = async () => {
    setLoadingEnterprises(true);

    try {
      const response = await enterprisesService.getEnterprises({
        regional: regionalOp,
        bairro: neighborhoods,
        somenteDisponiveis: true,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingEnterprises(false);
        setDataEnterprises([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingEnterprises(false);
        setIsUnauthorized(true);
        setDataEnterprises([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataEnterprises(dataArray);
      setLoadingEnterprises(false);
    } catch (error) {
      setLoadingEnterprises(false);
      console.log("errorHandleGetEnterprises", error);
    }
  };

  const handleGetNeighborhoods = async () => {
    setLoadingNeighborhoods(true);

    try {
      const response = await enterprisesService.getNeighborhoods({
        idEmpreendimentoSales: idEnterprises,
        regional: regionalOp,
      });

      if (response.status >= 400 && response?.status !== 401) {
        // setLoadingNeighborhoods(false);
        setDataNeighborhoods([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        // setLoadingNeighborhoods(false);
        setIsUnauthorized(true);
        setDataNeighborhoods([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataNeighborhoods(dataArray);
      // setLoadingNeighborhoods(false);
    } catch (error) {
      // setLoadingNeighborhoods(false);
      console.log("errorHandleGetNeighborhoods", error);
    } finally {
      setLoadingNeighborhoods(false);
    }
  };

  const handleGetTypology = async () => {
    setLoadingTypology(true);
    try {
      const response = await unityService.getTypology({
        idEmpreendimentoSales: idEnterprises,
        bairro: neighborhoods,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingTypology(false);
        console.log("status 400", response);
        return;
      }

      if (response?.status === 401) {
        setLoadingTypology(false);
        console.log("status 401", response);
        return;
      }

      const dataArray: any = Object.values(response);

      setLoadingTypology(false);
      setDataTypology(dataArray ? dataArray : []);
    } catch (error: any) {
      setLoadingTypology(false);
      console.log("errorHandleGetTypology", error);
    }
  };

  const handleGetConditionPayment = async () => {
    setLoadingPaymentTerms(true);
    try {
      const response = await quotesService.getConditionPayment({
        empreendimentoId: idEnterprises,
        ranking,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingPaymentTerms(false);
        console.log("status 400", response);
        return;
      }

      if (response?.status === 401) {
        setLoadingPaymentTerms(false);
        console.log("status 401", response);
        setIsUnauthorized(true);
        return;
      }

      setDataDescription(
        response?.map((data: any) => {
          return data?.descricao;
        })
      );
      setLoadingPaymentTerms(false);
      setDataPaymentTerms(response ? response : []);
    } catch (error: any) {
      setLoadingPaymentTerms(false);
      console.log("errorHandleGetConditionPayment", error);
    }
  };

  const handleGetCreditRating = async () => {
    setLoadingCreditRating(true);
    try {
      const response = await oportunityService.getCreditRating({
        OpportunityIdSalesforce: accessCreateOp.oportunityIdSalesforce,
        idEmpreendimentoSales: idEnterprises,
        somenteAprovadas: true,
      });

      if (response.status === 401) {
        setLoadingCreditRating(false);
        return;
      }

      setDataCreditRating(response ? response : []);
      setLoadingCreditRating(false);
    } catch (error) {
      setLoadingCreditRating(false);
      console.log("ErrorHandleGetCreditRating", error);
    }
  };

  const displayMessage = ({ message }: { message: string }) => {
    toast.closeAll();
    toast({
      position: "top-right",
      status: undefined,
      duration: 6000,
      render: () => (
        <Styled.ContainerToastButton>
          <Styled.ContainerHeaderToast>
            <span>Bora Vender</span>
            <CloseButton onClick={() => toast.closeAll()} />
          </Styled.ContainerHeaderToast>

          <Styled.ContainerMessageToast>
            <span>{message}</span>
          </Styled.ContainerMessageToast>

          <Styled.ContainerButtonToast>
            <Button
              title={"ACESSAR COTAÇÃO"}
              onClick={() => {
                setSuccessCreateQuote(false);
                setHash("ViewQuotesComponent");
              }}
            />
          </Styled.ContainerButtonToast>
        </Styled.ContainerToastButton>
      ),
      containerStyle: {
        maxWidth: "350px",
        marginTop: "5px",
        boxShadow: "dark-lg",
        borderRadius: "8px",
        bg: "white",
      },
    });
  };

  const handleCreateQuote = async () => {
    setLoading(true);
    setSuccessCreateQuote(false);
    try {
      const response = await quotesService.createQuote({
        opportunityIdSalesforce: accessCreateOp.oportunityIdSalesforce,
        idAvaliacaoCreditoSalesforce: idCreditRating,
        idCotacaoSalesforce: accessQuote.idCotacaoSalesforce,
        idEmpreendimentoSales: idEnterprises,
        contactIdSalesforceCorretorLogado: idCorretor,
        nomeDaCotacao: accessQuote.nomeDaCotacao,
        condicaoPagamentoMatrizSelecionada: idPaymentTerms,
        produto: unity.idUnidadeSales,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoading(false);
        displayMessageError({
          message: response.data ? response.data : "Erro ao criar cotação!",
        });
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoading(false);
        setIsUnauthorized(true);
        return;
      }

      displayMessage({ message: "Cotação criada com sucesso!" });
      setSuccessCreateQuote(true);
      setIsEdit(false);
      setAccessQuote({
        idCotacaoSalesforce: response?.idCotacaoSalesforce,
        nomeDaCotacao: response?.nomeDaCotacao,
      });
      onBack();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errorHandleCreateSchedule", error);
    }
  };

  const handleChangeMoney = (
    event: React.ChangeEvent<HTMLInputElement> | FormEvent<HTMLInputElement>,
    setValue: React.Dispatch<React.SetStateAction<string>>
  ) => {
    let inputValue = (event.target as HTMLInputElement).value;

    inputValue = inputValue.replace(/\D/g, "");

    const numericValue = Number(inputValue) / 100;

    const formattedValue = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(numericValue);

    setValue(formattedValue);
  };

  const CreateQuoteHashMap: IHashMapKeyString = {
    SelectUnity: (
      <>
        <VStack>
          <Grid
            templateColumns="repeat(5, 1fr)"
            templateAreas={{
              base: `
          "empreendimento"
          "bairro"
          "tipologia"
          "valorMin"
          "valorMax"
        `,
              md: `
          "empreendimento bairro tipologia valorMin valorMax"
          
        `,
            }}
            gridTemplateColumns={{
              base: "1fr",
              md: "3fr 2fr 2fr 1fr 1fr",
              // "2xl": "1fr 2fr 2fr",
            }}
            gap={2}
          >
            <GridItem area="empreendimento" w="100%">
              <InputSelectSearch
                isRequirement
                width="30%"
                height="45%"
                title="Empreendimento:"
                placeholder="Pesquise por empreendimento"
                value={selectEnterprises}
                onChangeInput={(e) => setSelectEnterprises(e.target.value)}
                isSelected={enterprises}
                onChangeIcon={() => {
                  setEnterprises("");
                  setSelectEnterprises("");
                  setIdEnterprises("");
                }}
                onClickSearchIcon={handleGetEnterprises}
                loading={loadingEnterprises}
              >
                {renderedOptions}
              </InputSelectSearch>
            </GridItem>

            <GridItem area="bairro" w="100%">
              <InputSelectSearch
                width="20%"
                height="45%"
                title="Bairro:"
                placeholder="Pesquise por bairro"
                value={selectNeighborhoods}
                onChangeInput={(e) => setSelectNeighborhoods(e.target.value)}
                isSelected={neighborhoods}
                onChangeIcon={() => {
                  setIdNeighborhoods("");
                  setNeighborhoods("");
                  setSelectNeighborhoods("");
                }}
                onClickSearchIcon={handleGetNeighborhoods}
                loading={loadingNeighborhoods}
              >
                {renderedOptionsNeighborhoods}
              </InputSelectSearch>
            </GridItem>

            <GridItem area="tipologia" w="100%">
              <InputSelectSearch
                width="20%"
                height="45%"
                title="Tipologia:"
                placeholder="Pesquise por tipologia"
                value={selectTypology}
                onChangeInput={(e) => setSelectTypology(e.target.value)}
                isSelected={typology}
                onChangeIcon={() => {
                  setTypology("");
                  setSelectTypology("");
                }}
                onClickSearchIcon={handleGetTypology}
                loading={loadingTypology}
                disabled={!idEnterprises && !selectNeighborhoods}
              >
                {renderedOptionsTypology}
              </InputSelectSearch>
            </GridItem>

            <GridItem area="valorMin" w="100%">
              <InputText
                label="Valor"
                name="valorMin"
                placeholder={"Mínimo"}
                value={valueMin}
                onChange={(e) => handleChangeMoney(e, setValueMin)}
                iconSee={false}
                readOnly={!idEnterprises && !selectNeighborhoods}
              />
            </GridItem>

            <GridItem area="valorMax" w="100%" mt={isMobile ? "0" : "18px"}>
              <InputText
                label=""
                name="valorMax"
                placeholder={"Máximo"}
                value={valueMax}
                onChange={(e) => handleChangeMoney(e, setValueMax)}
                iconSee={false}
                readOnly={!idEnterprises && !selectNeighborhoods}
              />
            </GridItem>
          </Grid>
        </VStack>

        <VStack>
          {loadingUnity ? (
            <Flex
              flexDirection={"column"}
              w={"100%"}
              minH={"300px"}
              alignItems={"center"}
              justify={"center"}
              mt={"20px"}
            >
              <Spinner />
            </Flex>
          ) : dataUnity.length === 0 ? (
            <Flex
              flexDirection={"column"}
              w={"100%"}
              minH={"300px"}
              alignItems={"center"}
              justify={"center"}
              mt={"20px"}
            >
              <IconLupaError width="180px" height="180px" />
              <Text
                fontSize={"18px"}
                fontWeight={"medium"}
                color={theme.text}
                textAlign={"center"}
              >
                Utilize um ou mais filtros acima para ver as unidades
                disponíveis
              </Text>

              <Text
                fontSize={"13px"}
                color={theme.text50}
                textAlign={"center"}
                w={{ base: "280px", md: "480px" }}
                mt={"8px"}
              >
                Você pode filtrar por empreendimento, bairro, tipologia ou valor
                mínimo/máximo
              </Text>
            </Flex>
          ) : (
            <Flex flexDirection={"column"} w={"100%"} mt={"20px"} gap={"10px"}>
              <Box
                display="flex"
                width={isMobile ? "100%" : "25%"}
                flexDirection={isMobile ? "column" : "row"}
                alignItems={isMobile ? "baseline" : "center"}
              >
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <BiSearch color={theme.primary} />
                  </InputLeftElement>
                  <Input
                    variant="flushed"
                    fontSize={14}
                    _focus={{
                      borderBottomColor: theme.primary,
                    }}
                    borderBottomColor={theme.disable}
                    placeholder={`Pesquisar nesta lista...`}
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </InputGroup>
              </Box>

              <Flex
                flexDir="column"
                w={"100%"}
                minH={"100%"}
                maxH={{ base: "auto", xl: "320px", "2xl": "600px" }}
                overflow={"auto"}
              >
                <Flex>
                  <TableUnity
                    data={dataUnity}
                    onClick={() => setHashCreateQuote("ConfirmCreateQuote")}
                    searchFilter={search}
                    setUnity={setUnity}
                    setIdEnterprises={setIdEnterprises}
                  />
                </Flex>
              </Flex>
            </Flex>
          )}
        </VStack>
      </>
    ),
    ConfirmCreateQuote: (
      <>
        <Flex>
          <Box
            w="365px"
            h="200px"
            border={"1px"}
            borderColor={theme.disable100}
            borderRadius={"12px"}
            p={"22px"}
            boxShadow={"md"}
          >
            <Flex gap={"10px"}>
              <Box
                display={"flex"}
                w="62px"
                h="50px"
                borderRadius={"full"}
                bg={theme.disable100}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <MdHomeWork color={theme.primary} fontSize={"18"} />
              </Box>

              <Box display={"flex"} flexDir={"column"} gap={"8px"}>
                <Text w={"fit-content"} fontSize={"14px"} fontWeight={"medium"}>
                  {unity?.nomeEmpreendimento}
                </Text>
                <Text w={"fit-content"} fontSize={"12px"}>
                  Unidade {unity?.identificador}
                </Text>
              </Box>
            </Flex>

            <Flex mt={"20px"} gap={"14px"}>
              <Text w="fit-content" fontSize={"12px"}>
                <strong>Tipo </strong>
                {unity?.tipoPlanta?.replace("Tipo", "")}
              </Text>
              <Text w="fit-content" fontSize={"12px"}>
                <strong>Valor </strong> {formatMoney(unity?.valorFinalKit)}
              </Text>
            </Flex>

            <Flex mt={"12px"} gap={"14px"}>
              <Text w="fit-content" fontSize={"12px"}>
                <strong>Avaliação </strong>
                {formatMoney(unity?.valorAvalBancaria)}
              </Text>
              <Text w="fit-content" fontSize={"12px"}>
                <strong>B.A </strong> {formatMoney(unity?.bonusAdimplencia)}
              </Text>
            </Flex>

            <Flex mt={"20px"} gap={"8px"}>
              <Box w={"fit-content"}>
                <MdOutlineEdit color={theme.primary} fontSize={"18px"} />
              </Box>
              <Text
                as={"a"}
                w="fit-content"
                fontSize={"12px"}
                fontWeight={"medium"}
                color={theme.primary}
                textDecor={"underline"}
                cursor={"pointer"}
                onClick={() => setHashCreateQuote("SelectUnity")}
              >
                Escolher outra unidade
              </Text>
            </Flex>
          </Box>
        </Flex>

        <Flex flexDirection={"column"} mt={"30px"} gap={"15px"}>
          <InputSelectWithService
            isRequirement
            widht="60%"
            height="36%"
            title="Condição de Pagamento:"
            label={paymentTerms || "Selecione uma opção"}
            isSelected={paymentTerms}
            options={dataPaymentTerms}
            selectedOption={paymentTerms}
            onClick={() => handleGetConditionPayment()}
            onChange={(e) => setPaymentTerms(e.target.value)}
            setId={setIdPaymentTerms}
            loading={loadingPaymentTerms}
            // disabled={!selectEnterprises || !neighborhoods}
            description={dataDescription}
          />

          <InputSelectSearch
            width="60%"
            height="36%"
            title="Avaliação de crédito:"
            placeholder="Pesquise por avaliação"
            value={selectCreditRating}
            onChangeInput={(e) => setSelectCreditRating(e.target.value)}
            isSelected={creditRating}
            onChangeIcon={() => {
              setCreditRating("");
              setSelectCreditRating("");
            }}
            onClickSearchIcon={handleGetCreditRating}
            loading={loadingCreditRating}
          >
            {renderedOptionsCreditRating}
          </InputSelectSearch>
        </Flex>

        <Flex align={"center"} justify={"flex-end"} mt={"30px"}>
          <Box w="140px">
            <Button
              title={loading ? <Spinner /> : "Criar cotação"}
              onClick={handleCreateQuote}
              disabled={require || loading}
            />
          </Box>
        </Flex>
      </>
    ),
  };

  React.useEffect(() => {
    if (!idNeighborhoods && !idEnterprises) {
      setTypology("");
      setSelectTypology("");
      setDataUnity([]);
    }
  }, [idEnterprises, idNeighborhoods]);

  React.useEffect(() => {
    const isRequirement = !paymentTerms;

    setRequire(isRequirement);
  }, [paymentTerms]);

  React.useEffect(() => {
    if (!idEnterprises && !idNeighborhoods) return;

    const delayDebounce = setTimeout(() => {
      const handleGetUnity = async () => {
        setLoadingUnity(true);

        const valueFormat = (valor: string) => {
          if (!valor) return "";
          const cleaned = valor.replace(/\D/g, "");
          return cleaned.slice(0, -2); // remove os dois últimos dígitos (centavos)
        };

        try {
          const response = await unityService.getUnity({
            idEmpreendimentoSales: idEnterprises,
            bairro: neighborhoods,
            somenteDisponiveis: true,
            tipologia: typology,
            valorMinimo: valueFormat(valueMin),
            valorMaximo: valueFormat(valueMax),
          });

          if (response.status >= 400 && response?.status !== 401) {
            console.log("status 400", response);
            return;
          }

          if (response?.status === 401) {
            console.log("status 401", response);
            return;
          }

          const dataArray: any = Object.values(response);
          setDataUnity(dataArray ? dataArray : []);
        } catch (error: any) {
          console.log("errorHandleGetUnity", error);
        } finally {
          setLoadingUnity(false);
        }
      };

      handleGetUnity();
    }, 500); // 500ms de debounce

    return () => clearTimeout(delayDebounce);
  }, [
    idEnterprises,
    idNeighborhoods,
    typology,
    valueMin,
    valueMax,
    neighborhoods,
  ]);

  return (
    <>
      <Alert
        onOpen={isUnauthorized}
        title="Sessão expirada"
        titleButton={"Fazer login novamente"}
        description={
          "Sua sessão expirou, faça login novamente para ter acesso."
        }
        onClick={() => {
          signOut();
        }}
      />

      {CreateQuoteHashMap[hashCreateQuote]}
    </>
  );
};

export default CreateQuotesComponent;
